const CORE_TRANSLATION_GROUP = 'core'
const APPLICATION_TRANSLATION_GROUP = 'application'
const RECEIVED_REQUEST_REPLY_TRANSLATION_GROUP = 'received-request-reply'
const PRODUCT_COMPLIANCE_TRANSLATION_GROUP = 'product-compliance'
const SUPPLIER_SELECTION_TRANSLATION_GROUP = 'supplier-selection'
const DOCUMENT_REVIEW_TRANSLATION_GROUP = 'document-review'

export {
    APPLICATION_TRANSLATION_GROUP,
    CORE_TRANSLATION_GROUP,
    DOCUMENT_REVIEW_TRANSLATION_GROUP,
    PRODUCT_COMPLIANCE_TRANSLATION_GROUP,
    RECEIVED_REQUEST_REPLY_TRANSLATION_GROUP,
    SUPPLIER_SELECTION_TRANSLATION_GROUP,
}
